import { isEqual, isObject } from 'lodash';
import userActions from '../actions/userActions';
import update from 'immutability-helper';

const userReducer = (state = {}, action) => {
  switch (action.type) {
    case userActions.constants.notify:
      if (!isObject(action.payload)) {
        return null;
      }

      return update(state, { notifications: { $unshift: [action.payload] } });
    case userActions.constants.denotify:
      if (!isObject(action.payload)) {
        return null;
      }

      const itemIndex = state.notifications.findIndex(
        (item) => item.id === action?.payload?.id,
      );

      return update(state, { notifications: { $splice: [[itemIndex, 1]] } });
    case userActions.constants.set:
      if (!isObject(action.payload)) {
        return null;
      }

      const updatedState = { ...state, ...action.payload };

      if (isEqual(state, updatedState)) {
        return state;
      }

      return updatedState;
    default:
      return state;
  }
};

export default userReducer;
